import {promiseWithTimeout} from '../utils/promise-with-timeout';

export const ECID = async () => {
  try {
    const alloy = (window as any)?.alloy;
    if (alloy && typeof alloy === `function`) {
      const {identity}: any = await promiseWithTimeout(
        alloy(`getIdentity`),
        300,
      );
      return identity.ECID as string;
    }
  } catch (error) {
    console.warn(`ECID not found`);
  }

  return;
};
